import React, { useEffect, useState, useRef } from 'react';

import { getAllArticles, getCategories } from '../../../../services/blog';

import blogCategories from '../../../../utils/blogCategories';

import Articals from './sections/articals';
import { NavigationBar, NavigationForMob } from './sections/navigationBar';

import Pagination from './sections/pagination';
import NoResulte from './sections/noResults';

import st from './index.module.scss';

const WhatNew = () => {
  const limit = 6;
  const [articles, setArticles] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [category, setCategory] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [showNoResult, setShowNoResult] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const sideBar = useRef(null);

  const onPageChange = newPage => {
    setCurrentPage(newPage);
  };

  const handleCategoryChange = newCategory => {
    setCategory(newCategory);
    setSearch('');
  };

  const handleSearch = newSearch => {
    setSearch(newSearch);
  };

  useEffect(() => {
    setLoading(true);

    getAllArticles(category, search, limit, currentPage).then(data => {
      setShowNoResult(data.posts.length === 0);

      setArticles(data.posts);
      setTotalPages(Math.ceil(data.total / limit));
      setLoading(false);
    });
  }, [currentPage, search, category]);

  useEffect(() => {
    document.body.classList.remove('overflow-x-hidden');
    setCategoryLoading(true);
    getCategories().then(data => {
      const categoryData = blogCategories(data);
      setCategorys(categoryData);
      setCategoryLoading(false);
    });
  }, []);

  return (
    <div className="md:bg-[#F4F5F7] bg-white flex flex-col justify-center items-center md:py-[48px] pb-[48px] gap-[48px]">
      <div className={`w-full flex justify-center items-center -translate-y-1/2 md:hidden  h-[50px] ${st['stickyBar']}`} ref={sideBar}>
        <NavigationForMob categorys={categorys} category={category} onCategoryChange={handleCategoryChange} />
      </div>
      <NavigationBar
        categorys={categorys}
        category={category}
        loading={categoryLoading}
        onCategoryChange={handleCategoryChange}
        onSearch={handleSearch}
      />
      {showNoResult ? (
        <NoResulte />
      ) : (
        <>
          <Articals articles={articles} loading={loading} limit={limit} />

          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
        </>
      )}
    </div>
  );
};

export default WhatNew;
